import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { ExternalLink } from '../../components';

import css from './AboutPage.module.css';

import element1 from '../../assets/team-shape1.png';
import element2 from '../../assets/team-shape2.png';
import element3 from '../../assets/team-shape3.png';
import element4 from '../../assets/team-shape4.png';

import yainnis from '../../assets/advisory/yiannis.png';
import beth from '../../assets/advisory/Beth.jpg';
import petros from '../../assets/advisory/petros.jpg';
import sabine from '../../assets/advisory/Sabine.png';
import nik from '../../assets/advisory/nikolaos.jpg';
import martha from '../../assets/advisory/martha.jpg';
import harry from '../../assets/advisory/harry.jpg';

import IconLinkedin from '../../components/IconLinkedin/IconLinkedin';
import { isLocaleGreek } from '../../util/genericHelpers';
import IconWebsite from '../../components/IconWebsite/IconWebsite';

function SectionAdvisory() {
  // Array of team members
  const teamMembers = [
    {
      imageUrl: nik,
      altText: 'Nikolaos Vlahos, M.D, F.A.C.O.G.',
      nameKey: 'SectionAdvisory.employeeName1',
      infoKey: 'SectionAdvisory.employeeInfo1',
      infoKey2: 'SectionAdvisory.employeeInfo11',
      tagKey: 'SectionAdvisory.tag1',
      websiteUrl: 'https://www.nikolaosvlahos.gr',
      linkedInUrl: 'https://www.linkedin.com/in/nikos-f-vlahos-md-phd-bb882456',
    },
    {
      imageUrl: yainnis,
      altText: 'Yiannis Zervas',
      tagKey: 'SectionAdvisory.tag2',
      nameKey: 'SectionAdvisory.employeeName2',
      infoKey: 'SectionAdvisory.employeeInfo2',
      infoKey2: 'SectionAdvisory.employeeInfo22',
    },
    {
      imageUrl: beth,
      altText: 'Beth Hirschhorn',
      nameKey: 'SectionAdvisory.employeeName3',
      infoKey: 'SectionAdvisory.employeeInfo3',
      infoKey2: 'SectionAdvisory.employeeInfo33',
      tagKey: 'SectionAdvisory.tag3',
      linkedInUrl: 'https://www.linkedin.com/in/beth-hirschhorn-a176aba0/',
    },
    // {
    //   imageUrl: sabine,
    //   altText: 'Dr. Sabine Wünschmann',
    //   nameKey: 'SectionAdvisory.employeeName4',
    //   infoKey: 'SectionAdvisory.employeeInfo4',
    //   infoKey2: 'SectionAdvisory.employeeInfo44',
    //   tagKey: 'SectionAdvisory.tag4',
    //   websiteUrl: 'https://www.doctorsabine.com',
    // },
    {
      imageUrl: petros,
      altText: 'Πέτρος Ευθυμίου, MD, FACR',
      nameKey: 'SectionAdvisory.employeeName5',
      infoKey: 'SectionAdvisory.employeeInfo5',
      infoKey2: 'SectionAdvisory.employeeInfo55',
      tagKey: 'SectionAdvisory.tag5',
      websiteUrl: 'https://drpetrosefthimiou.com',
      linkedInUrl: 'https://www.linkedin.com/in/drpetros',
    },
    {
      imageUrl: martha,
      altText: 'Μάρθα Μυλωνά',
      nameKey: 'SectionAdvisory.employeeName7',
      infoKey: 'SectionAdvisory.employeeInfo7',
      infoKey2: 'SectionAdvisory.employeeInfo77',
      tagKey: 'SectionAdvisory.tag7',
      linkedInUrl: 'https://www.linkedin.com/in/marthamylona',
    },
    {
      imageUrl: harry,
      altText: 'Dr. Harry Tschebiner',
      nameKey: 'SectionAdvisory.employeeName8',
      infoKey: 'SectionAdvisory.employeeInfo8',
      infoKey2: 'SectionAdvisory.employeeInfo88',
      tagKey: 'SectionAdvisory.tag8',
      linkedInUrl: 'https://www.linkedin.com/in/dr-med-harry-tschebiner-b6046890',
    },
  ];

  const TeamMember = ({
    imageUrl,
    altText,
    nameKey,
    infoKey,
    tagKey = '',
    infoKey2 = '',
    linkedInUrl,
    websiteUrl,
  }) => {
    const [showMore, setShowMore] = useState(false);
    return (
      <div className={css.team}>
        <div className={css.teamInfo}>
          <div className={css.teamImg}>
            <img src={imageUrl} alt={altText} />
          </div>
          <h2>
            <FormattedMessage id={nameKey} />
          </h2>
          <p className={css.title}>
            <FormattedMessage id={tagKey} />
          </p>
          <p>
            <FormattedMessage id={infoKey} />
            {!showMore ? (
              <span className={css.showMore} onClick={() => setShowMore(!showMore)}>
                <FormattedMessage id="SectionAdvisory.showMore" />
              </span>
            ) : null}
            {showMore ? <FormattedMessage id={infoKey2} /> : null}
            {showMore ? (
              <span className={css.showMore} onClick={() => setShowMore(!showMore)}>
                <FormattedMessage id="SectionAdvisory.showLess" />
              </span>
            ) : null}
          </p>
        </div>
        <div className={css.websiteUrl}>
          {websiteUrl ? (
            <ExternalLink href={websiteUrl}>
              <IconWebsite />
            </ExternalLink>
          ) : null}
          {linkedInUrl ? (
            <ExternalLink href={linkedInUrl}>
              <IconLinkedin />
            </ExternalLink>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <div className={css.ourTeamContainer}>
      <span className={css.shape1}>
        <img src={element1} alt="element" />
      </span>
      <span className={css.shape2}>
        <img src={element2} alt="element" />
      </span>
      <span className={css.shape3}>
        <img src={element3} alt="element" />
      </span>
      <span className={css.shape4}>
        <img src={element4} alt="element" />
      </span>
      <div className={css.contentWidth}>
        <section className={css.ourTeamContent}>
          <h2>
            <FormattedMessage id="AboutPage.sectionAdvisory" />
          </h2>
          <div className={css.teamBlock}>
            {teamMembers.map((member, index) => (
              <TeamMember key={index} {...member} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default SectionAdvisory;
